import "core-js/modules/es.array.concat";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.to-string";
import { getLanguage } from "web/script/modules/language";
import { getURL } from "web/script/routing/getUrl";

function urlFetcher(name, transform) {
  var savedLanguage;
  var transformed;
  return function () {
    var currentLanguage = getLanguage();

    if (savedLanguage != currentLanguage || !transformed) {
      var _url = getURL(name);

      if (!_url) {
        throw new Error("URL ".concat(name, " does not exist in ").concat(currentLanguage, "!"));
      }

      savedLanguage = currentLanguage;
      transformed = transform(_url);
    }

    return transformed;
  };
} // Tests


export { urlFetcher as _urlFetcher };
export var getProductPageRegex = urlFetcher("productPageRegex", function (url) {
  return new RegExp(url);
});
export var getSearchPageRegex = urlFetcher("searchPage", function (url) {
  return new RegExp("^/?".concat(url, "/$"));
});
export var getSignupPageRegex = urlFetcher("signupPageRegex", function (url) {
  return new RegExp(url);
});
export function getSearchPageURL() {
  return "/".concat(getURL("searchPage"), "/");
}
export function getRothkoEndpoint() {
  // This code assumes we will never not have a rothko endpoint.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return getURL("rothkoEndpoint");
}